<template>

	<!--顶部：导航 开始-->
<div class="head-nav clear-l">
	<div class="div">
	<div class="w1200 bc">
        <!--导航-->
        <ul class="nav fl">
            <li>
                <a v-bind:class='{"active":activeLi === "purchaser"}' v-bind:href="purchaserUrl">采购商服务</a>
            </li>
            <li>
                <a v-bind:class='{"active":activeLi === "mallIndex"}' @click="goIndex()">商城首页</a>
            </li>
            <li>
                <a v-bind:class='{"active":activeLi === "brand"}'  v-bind:href="brandUrl">品牌导航</a>
            </li>
            <li>
                <a v-bind:class='{"active":activeLi === "sample"}'  @click="goSample()">样品中心</a>
            </li>
            <li>
                <a v-bind:class='{"active":activeLi === "requirement"}' v-bind:href="requirementUrl">需求中心</a>
            </li>
            <li>
                <a v-bind:class='{"active":activeLi === "tradingHall"}' v-bind:href="tradingHallUrl">交易大厅</a>
            </li>
            <li>
                <a v-bind:class='{"active":activeLi === "meterial"}' @click="goMeterial()">原材料</a>
            </li>
            <li>
                <a v-bind:class='{"active":activeLi === "news"}' v-bind:href="newsUrl">新闻百科</a>
            </li>
            <li>
                <a v-bind:class='{"active":activeLi === "exhibition"}' v-bind:href="exhibitionUrl">展会</a>
            </li>
        </ul>
        
        <!--商城分类-->
    	<div class="mall-categorys" v-if="firstCatShow">
        	
            <div class="sc-submenu">
            	<ul>
            		<li>
            			<div class="category-head" >箱包分类
            			<div class="category-head-border"></div>
            			</div>
            		</li>
                	<li v-for="(cat,index) in catList" :class="'li-'+(index+1)"  v-on:mouseleave="childCateHide()"  v-on:mouseenter="childCateShow(index)" >
                    	<div class="yj" >
                            <a @click="getMore(cat.catCode,cat.catNameCn)">{{cat.catNameCn}}</a>
                            <!--<i class="sc-ico-arrow"></i>-->
                        </div>
                        <div class="sc-submenu-all" v-bind:class='{"none":currIndex != index}'  :style="'top:'+index*(-45)+'px'"  v-on:mouseleave="childCateHide()">
                            <dl>
                            	<dt>{{cat.catNameCn}}</dt>
                                <dd>
                                	<a v-for="childCat in cat.catBoList" @click="getCatGoods(childCat.catCode,childCat.catNameCn)">{{childCat.catNameCn}}</a>
                                	<a @click="getMore(cat.catCode,cat.catNameCn)">更多</a>
                                </dd>
                            </dl>
                            
                        </div>
                   </li>
                </ul>
            </div>
        </div>
        
        </div>
    </div>
</div>
<!--顶部：导航 结束-->

</template>

<script>
 	import API from "../../static/api/api.js"
 	import jQuery from 'jquery';
	export default {
    	name: 'hearderNav',
        data(){
            return {
		        navSelectCatList:[],
		        showFlag:true,
            	catList:[],
            	catListNew:[],
            	currIndex:-1,
				purchaserUrl:API.getPurchaserUrl(),
				brandUrl:API.getBrandUrl(),
				requirementUrl:API.getRequirementUrl(),
				tradingHallUrl:API.getTradingHallUrl(),
				newsUrl:API.getNewsUrl(),
				exhibitionUrl:API.getExhibitionUrl(),
            }
        },
        props: [
        	'isRefresh',
        	'activeLi',
        	'firstCatShow'
        ],
		components: {
			
		},
		methods:{
			goIndex:function(){
		  		this.$router.push({name:'index'});
		  	},
		  	goSample:function(){
		  		this.$router.push({name:'goodsList',query: {productType:"sample",orderType:"proof"}});
		  		window.location.reload();
		  	},
		  	goMeterial:function(){
		  		this.$router.push({name:'meterialList',query: {productType:"meterial"}});
		  		window.location.reload();
		  	},
			childCateHide:function(){
				this.currIndex=-1;
			},
			childCateShow:function(index){
				this.currIndex=index;
			},
			wholeCateHide:function(){
			 	this.firstCatShow = false;
			 	this.showFlag = false;
			},
			wholeCateShow:function(){
			 	this.firstCatShow = true;
			},
			getMore:function(catCode,catNameCn){
		  	 	this.$router.push({name:'goodsList',query:{firstCatCode:catCode,catNameCn:catNameCn}});
		  		window.location.reload();
			},
		  	getCatGoods:function(catCode,catNameCn){
		  	 	this.$router.push({name:'goodsList',query:{catCode:catCode,catNameCn:catNameCn}});
		  	 	if(this.isRefresh){
		  	 		window.location.reload();
		  	 	}
		  	},
			getCat:function(){
				var that = this;
				//这里只查询现货类目
				API.getAllCat('product',function(ret){
					if(ret.code == "success"){
						var firstCatList = ret.data.firstCatList;
						if(firstCatList != undefined && firstCatList.length>0){
							var a = Math.ceil(firstCatList.length/8); 
							var b = (firstCatList.length)%8;		
							var c = 0;
							var carArray=[] ;
							for(var i =0;i<8;i++){
								var items = [];
								for(var j = 0; j < a; j++){
									if(c>=firstCatList.length)break;
									items = items.concat(firstCatList[c]);
									c++;
									if(i==b-1&&j==(a-1))a--;
								}
								if(items.length!=0){
									carArray.push(items)  
								}
								
							}
							that.catListNew = carArray;
							that.catList = firstCatList;
						}
					}
				});
			}
		},
		mounted(){
			
		}
	}
</script>
<style>
	.yj{
		float:left;
	}
	
</style>


// WEBPACK FOOTER //
// src/components/HearderNav.vue?0a8a4a06